import { render, staticRenderFns } from "./DCategoriesFilter.vue?vue&type=template&id=6c646d26&scoped=true&"
import script from "./DCategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./DCategoriesFilter.vue?vue&type=script&lang=js&"
import style0 from "./DCategoriesFilter.vue?vue&type=style&index=0&id=6c646d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c646d26",
  null
  
)

export default component.exports